import { Dropdown } from 'baby-design'
import { RegItem } from 'src/types/regItem'
import NiceModal from '@ebay/nice-modal-react'
import { RegItemCategory } from 'src/types/regItemCategory'
import { ProductCategory } from 'src/routes/(registry)/list/[slug]/components/RegItemCard/RegItemCard.types'
import AddUpdateCategoryDrawer from '../../AddUpdateCategoryDrawer/AddUpdateCategoryDrawer'

interface SelectValue {
  label: string
  value: any
}

interface CategoryDropdownProps {
  regItemFields: RegItem
  categories: Array<SelectValue>
  updateRegItemFields: (fields: object) => void
}

export function CategoryDropdown({
  regItemFields,
  categories,
  updateRegItemFields,
}: CategoryDropdownProps) {
  const newCategoryValue = {
    value: '_new',
    label: '+ New Category',
  }

  const categoryWithId = (categoryId: number) =>
    categories.find((cat) => cat.value === categoryId)

  const onChange = async (e: SelectValue | null) => {
    if (e === null) {
      return
    }

    if (e.value === newCategoryValue.value) {
      const response: RegItemCategory | undefined = await NiceModal.show(
        AddUpdateCategoryDrawer
      )
      if (response) {
        updateRegItemFields({
          categoryId: response.id,
          private: regItemFields.private && !response.isPrivate,
        })
      }
      return
    }

    const category = categoryWithId(e.value) as ProductCategory | undefined
    updateRegItemFields({
      categoryId: e.value,
      private: regItemFields.private && !category?.isPrivate,
    })
  }

  return (
    <Dropdown
      label="Category"
      options={[newCategoryValue, ...categories]}
      placeholder={<>Select&nbsp;Category...</>}
      size="md"
      value={categories.find(
        (category) => category.value === regItemFields.categoryId
      )}
      onChange={onChange}
    />
  )
}
